import "./navBar.css";
import { Link } from "react-scroll";

const Navbar = () => {
  const openResumeInNewTab = () => {
    window.open(
      "https://docs.google.com/document/d/16Bzf8vNnl4_KxHOF5UJ4iP3fhZLWmia_YAz8VQPMKcI/edit?usp=sharing"
    );
  };

  return (
    <nav className="navbar">
      <div className="dummy"></div>
      <div className="desktopMenu">
        <Link
          activeClass="active"
          to="intro"
          spy={true}
          smooth={true}
          offset={-100}
          duration={500}
          className="desktopMenuListItem"
        >
          Home
        </Link>
        <Link
          activeClass="active"
          to="skills"
          spy={true}
          smooth={true}
          offset={10}
          duration={500}
          className="desktopMenuListItem"
        >
          Skills
        </Link>
        <Link
          activeClass="active"
          to="portfolio"
          spy={true}
          smooth={true}
          offset={20}
          duration={500}
          className="desktopMenuListItem"
        >
          Projects
        </Link>
        <Link
          activeClass="active"
          to="tWritting"
          spy={true}
          smooth={true}
          offset={20}
          duration={500}
          className="desktopMenuListItem"
        >
          Technical Writting
        </Link>
      </div>
      <div className="resBtn">
        <button className="desktopMenuBtn" onClick={openResumeInNewTab}>
          <a className="aRes"> View resume </a>
        </button>
      </div>
    </nav>
  );
};

export default Navbar;
